export default __webpack_public_path__ + "static/linktree-logo-0b87d9ba3b3fb30a43ae61da9f2894db.svg";